import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import EventSchedule16 from '@carbon/icons-react/es/event--schedule/16';
import * as React from 'react';
import { DATE_INPUT_DISPLAY_FORMAT } from 'api/models';
import { DatePicker } from 'components/facade/date-picker';
import { useTranslation } from 'hooks/use-translation';
import { DueDatePickerFooter } from './footer';
export const DueDateSinglePicker = ({ footerText, endDateText, canChooseStartDate, useAsStartDatePicker, hideFooter, hideClearDate, isTodayDisabled, isTomorrowDisabled, clearDates, modifyPickerType, pickToday, pickTomorrow, updateDates, onDone, dateRenderer, ...rest })=>{
    const defaultText = useTranslation('due_date');
    const dueDateText = endDateText !== null && endDateText !== void 0 ? endDateText : defaultText;
    return /*#__PURE__*/ _jsx(DatePicker, {
        ...rest,
        autoFocus: true,
        bordered: false,
        tabIndex: -1,
        showToday: false,
        open: true,
        format: DATE_INPUT_DISPLAY_FORMAT,
        placeholder: dueDateText,
        suffixIcon: /*#__PURE__*/ _jsx(EventSchedule16, {}),
        onChange: updateDates,
        dateRender: dateRenderer,
        renderExtraFooter: ()=>/*#__PURE__*/ _jsx(_Fragment, {
                children: !hideFooter ? /*#__PURE__*/ _jsx(DueDatePickerFooter, {
                    footerText: footerText,
                    canChooseStartDate: canChooseStartDate,
                    hideClearDate: hideClearDate,
                    type: "single",
                    onPickToday: pickToday,
                    onPickTomorrow: pickTomorrow,
                    onClear: clearDates,
                    modifyPickerType: modifyPickerType,
                    onDone: onDone,
                    useAsStartDatePicker: useAsStartDatePicker,
                    isTodayDisabled: isTodayDisabled,
                    isTomorrowDisabled: isTomorrowDisabled
                }) : /*#__PURE__*/ _jsx(_Fragment, {})
            })
    });
};
